
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("oYLAg"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("oYLAg", function(module, exports) {

let $04b160f68ba4a2dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04b160f68ba4a2dc$var$load("cRtGo"),
    $04b160f68ba4a2dc$var$load("7I05g"),
    $04b160f68ba4a2dc$var$load("93EyF"),
    $04b160f68ba4a2dc$var$load("6EuUL"),
    $04b160f68ba4a2dc$var$load("55OBD"),
    $04b160f68ba4a2dc$var$load("lbhYb"),
    $04b160f68ba4a2dc$var$load("emINS"),
    $04b160f68ba4a2dc$var$load("3BYXV"),
    $04b160f68ba4a2dc$var$load("c251E"),
    $04b160f68ba4a2dc$var$load("l8Ar8"),
    $04b160f68ba4a2dc$var$load("gFEtJ"),
    $04b160f68ba4a2dc$var$load("7jSfd"),
    $04b160f68ba4a2dc$var$load("4HZlX"),
    $04b160f68ba4a2dc$var$load("kDqHr"),
    $04b160f68ba4a2dc$var$load("gT8XU"),
    $04b160f68ba4a2dc$var$load("3GuOt"),
    $04b160f68ba4a2dc$var$load("8l20h"),
    $04b160f68ba4a2dc$var$load("9aQIt"),
    $04b160f68ba4a2dc$var$load("XZauT"),
    $04b160f68ba4a2dc$var$load("4S1SF"),
    $04b160f68ba4a2dc$var$load("lm9Lt"),
    $04b160f68ba4a2dc$var$load("9wPDc"),
    $04b160f68ba4a2dc$var$load("1MWOL"),
    $04b160f68ba4a2dc$var$load("6fQco"),
    $04b160f68ba4a2dc$var$load("aOY32"),
    $04b160f68ba4a2dc$var$load("3MYQs"),
    $04b160f68ba4a2dc$var$load("6SWFK"),
    $04b160f68ba4a2dc$var$load("5zapo"),
    $04b160f68ba4a2dc$var$load("jiFtb"),
    $04b160f68ba4a2dc$var$load("9atVd"),
    $04b160f68ba4a2dc$var$load("iivLa"),
    $04b160f68ba4a2dc$var$load("6wr18"),
    $04b160f68ba4a2dc$var$load("dek7I"),
    $04b160f68ba4a2dc$var$load("6iz6l"),
    $04b160f68ba4a2dc$var$load("4SCW2"),
    $04b160f68ba4a2dc$var$load("fdKpi"),
    $04b160f68ba4a2dc$var$load("ffEVr"),
    $04b160f68ba4a2dc$var$load("hhss7"),
    $04b160f68ba4a2dc$var$load("l22f4"),
    $04b160f68ba4a2dc$var$load("eTYdV"),
    $04b160f68ba4a2dc$var$load("Wowvf"),
    $04b160f68ba4a2dc$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("6M1M3"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("6M1M3", function(module, exports) {

let $4ee89a16db38a7c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ee89a16db38a7c5$var$load("cRtGo"),
    $4ee89a16db38a7c5$var$load("7I05g"),
    $4ee89a16db38a7c5$var$load("6wr18"),
    $4ee89a16db38a7c5$var$load("3j4Bc"),
    $4ee89a16db38a7c5$var$load("3BYXV"),
    $4ee89a16db38a7c5$var$load("c251E"),
    $4ee89a16db38a7c5$var$load("ffEVr"),
    $4ee89a16db38a7c5$var$load("fIjMV"),
    $4ee89a16db38a7c5$var$load("psI7s"),
    $4ee89a16db38a7c5$var$load("6bVVs"),
    $4ee89a16db38a7c5$var$load("7mo6o"),
    $4ee89a16db38a7c5$var$load("eTYdV"),
    $4ee89a16db38a7c5$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("euzmF"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("euzmF", function(module, exports) {

let $a8cf4cb261104ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a8cf4cb261104ea2$var$load("8W6E4"),
    $a8cf4cb261104ea2$var$load("c0JsV"),
    $a8cf4cb261104ea2$var$load("h3ABO"),
    $a8cf4cb261104ea2$var$load("61GLz"),
    $a8cf4cb261104ea2$var$load("55zKk"),
    $a8cf4cb261104ea2$var$load("dafa3"),
    $a8cf4cb261104ea2$var$load("iEUHW"),
    $a8cf4cb261104ea2$var$load("kbwlB"),
    $a8cf4cb261104ea2$var$load("2YffH"),
    $a8cf4cb261104ea2$var$load("9XOeB"),
    $a8cf4cb261104ea2$var$load("xu7ej"),
    $a8cf4cb261104ea2$var$load("iQ4FP"),
    $a8cf4cb261104ea2$var$load("T6sdO"),
    $a8cf4cb261104ea2$var$load("amnV8"),
    $a8cf4cb261104ea2$var$load("iVpKC"),
    $a8cf4cb261104ea2$var$load("9anPW"),
    $a8cf4cb261104ea2$var$load("5hHiM"),
    $a8cf4cb261104ea2$var$load("ekVkn"),
    $a8cf4cb261104ea2$var$load("6wmiZ"),
    $a8cf4cb261104ea2$var$load("im1VN"),
    $a8cf4cb261104ea2$var$load("eD3Si"),
    $a8cf4cb261104ea2$var$load("9JqIY"),
    $a8cf4cb261104ea2$var$load("ad7Qp"),
    $a8cf4cb261104ea2$var$load("16ESi"),
    $a8cf4cb261104ea2$var$load("gnDXu"),
    $a8cf4cb261104ea2$var$load("5XC9j"),
    $a8cf4cb261104ea2$var$load("93EyF"),
    $a8cf4cb261104ea2$var$load("6EuUL"),
    $a8cf4cb261104ea2$var$load("lbhYb"),
    $a8cf4cb261104ea2$var$load("emINS"),
    $a8cf4cb261104ea2$var$load("l8Ar8"),
    $a8cf4cb261104ea2$var$load("lTK3c"),
    $a8cf4cb261104ea2$var$load("1WXdc"),
    $a8cf4cb261104ea2$var$load("b2FtX"),
    $a8cf4cb261104ea2$var$load("2tuEe"),
    $a8cf4cb261104ea2$var$load("kzf0u"),
    $a8cf4cb261104ea2$var$load("7BszR"),
    $a8cf4cb261104ea2$var$load("hhss7"),
    $a8cf4cb261104ea2$var$load("6iz6l"),
    $a8cf4cb261104ea2$var$load("4SCW2"),
    $a8cf4cb261104ea2$var$load("bsnh1"),
    $a8cf4cb261104ea2$var$load("d43A9"),
    $a8cf4cb261104ea2$var$load("hdYRX"),
    $a8cf4cb261104ea2$var$load("9LC84"),
    $a8cf4cb261104ea2$var$load("5aEHs"),
    $a8cf4cb261104ea2$var$load("9HZKr"),
    $a8cf4cb261104ea2$var$load("cRtGo"),
    $a8cf4cb261104ea2$var$load("6wr18"),
    $a8cf4cb261104ea2$var$load("jvHRs"),
    $a8cf4cb261104ea2$var$load("3BYXV"),
    $a8cf4cb261104ea2$var$load("c251E"),
    $a8cf4cb261104ea2$var$load("Wowvf"),
    $a8cf4cb261104ea2$var$load("ffEVr"),
    $a8cf4cb261104ea2$var$load("fIjMV"),
    $a8cf4cb261104ea2$var$load("psI7s"),
    $a8cf4cb261104ea2$var$load("6bVVs"),
    $a8cf4cb261104ea2$var$load("7mo6o"),
    $a8cf4cb261104ea2$var$load("jnVKv"),
    $a8cf4cb261104ea2$var$load("7I05g"),
    $a8cf4cb261104ea2$var$load("7EorR"),
    $a8cf4cb261104ea2$var$load("bgHzk"),
    $a8cf4cb261104ea2$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.34ba845f.js.map
